import React from 'react';
import { AnalyticsEventSource } from '@atlassian/temp-analytics';
import { routePaths } from '@css-xp/ppc-constants';
import { PPCPageLoadExperienceKeys, withUFOWrapper } from '@css-xp/ppc-ufo';
import { AddPaymentMethodPage } from '@css-xp/ppc-add-payment-method-page';
import { ComingSoonPage } from '@css-xp/ppc-coming-soon-page';

export const routesWithoutNavigations = [
  {
    source: AnalyticsEventSource.PARTNER_ADD_PAYMENT_METHOD_SCREEN,
    exact: true,
    path: routePaths.addPaymentMethod,
    component: withUFOWrapper(AddPaymentMethodPage, PPCPageLoadExperienceKeys.AddPaymentMethodPage),
    key: 'addPaymentMethodPage',
  },
  {
    source: AnalyticsEventSource.PARTNER_COMING_SOON_SCREEN,
    exact: true,
    path: routePaths.accessPending,
    render() {
      return <ComingSoonPage />;
    },
    key: 'accessPending',
  },
];
